import React from 'react';
import { Modal } from 'antd';
import styles from './organizationModal.module.scss';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import { ReactNode } from 'react';
import clsx from 'clsx';
import ModalFooter, { ModalFooterProps } from '../ModalFooter';

interface OrganizationModalProps {
  visible: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  isExtraSpace?: boolean;
  width?: number;
  modalFooterProps?: ModalFooterProps;
  wrapClassName?: string;
}

export const modalCloseIcon = (
  <div className={styles.closeIcon}>
    <CloseIcon />
  </div>
);

const OrganizationModal: React.FC<OrganizationModalProps> = ({
  visible,
  onClose,
  title,
  children,
  isExtraSpace,
  width,
  modalFooterProps,
  wrapClassName,
}) => {
  //Footer component included for modals that are to be added further
  const modalFooter = modalFooterProps ? (
    <ModalFooter {...modalFooterProps} />
  ) : null;

  return (
    <Modal
      open={visible}
      destroyOnClose={true}
      zIndex={1000}
      width={width}
      maskClosable={false}
      title={title ? title : null}
      onCancel={onClose}
      footer={modalFooter}
      closeIcon={modalCloseIcon}
      centered={true}
      wrapClassName={clsx(styles.modalContainer, wrapClassName)}>
      <div
        className={clsx(
          isExtraSpace && styles.bodyContainerWithExtraSpace,
          styles.bodyContainer
        )}>
        {children}
      </div>
    </Modal>
  );
};

export default OrganizationModal;
